import { createSelector } from 'reselect';
import { getActivityTypes } from './getActivityTypes';
import { getIsJobLaborTrackingEnabled } from './getIsJobLaborTrackingEnabled';
import { getOpenActivityTypeMode } from './getOpenActivity';

export const getSwitchActivityTypesOptions = createSelector(
  [getActivityTypes, getOpenActivityTypeMode, getIsJobLaborTrackingEnabled],
  (activityTypes, openActivityTypeMode, isJobLaborTrackingEnabled) => {
    if (
      !isJobLaborTrackingEnabled ||
      !openActivityTypeMode ||
      !activityTypes?.length
    ) {
      return activityTypes;
    }

    return activityTypes.filter(({ activityMode }) => {
      return activityMode === openActivityTypeMode;
    });
  }
);
